import { Grid, Box, SpeedDial, Tabs, Tab, IconButton, SpeedDialAction, Tooltip } from "@mui/material";
import { Suspense, useEffect } from "react";
import Fab from "@mui/material/Fab";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { useContext } from "react";
import { useCallback, useMemo, useState } from "react";
import Draggable from "react-draggable";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import { useLocation, useHistory } from "react-router-dom";
import {
	DependentsContext,
	EnrollmentContext,
	AuthContext,
	ThemeContext,
	EligibleDependentContext
} from "../../../contexts";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./enrollment.css";
import KemperCancerForm from "./plans/kemper/cancer/form/CancerForm";
// import KemperCriticalIllnessForm from "./plans/kemper/criticalIllness/form/CriticalIllness";
// import KemperAccidentForm from "./plans/kemper/accident/form/AccidentForm";
// import KemperHospitalIndemnityForm from "./plans/kemper/hospitalIndemnity/form/HospitalIndemnityForm";
// import BeazleyIndemnityForm from "./plans/beazley/indemnity/form/IndemnityForm";
// import KemperWholeLifeInsuranceForm from "./plans/kemper/wholeLife/form/WholeLifeInsuranceForm";
// import KemperShortTermDisabilityForm from "./plans/kemper/shortTermDisability/form/ShortTermDisabilityForm";
// import FiveStarFamilyProtectionForm from "./plans/fiveStar/familyProtection/form/FamilyProtectionForm";
// import BeamVisionForm from "./plans/beam/vision/form/VisionForm";
// import DoctorAndRxForm from "./plans/doc/docAndRx/form/DocAndRx";
// import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Slide from "@mui/material/Slide";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import dayjs, { Dayjs } from "dayjs";
// import TextField from "@mui/material/TextField";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KemperCancerBranding from "./plans/kemper/cancer/branding/Branding";
import MaxDentalBranding from "./plans/macPlan/dental/branding/Branding";
import DownloadIcon from "@mui/icons-material/Download";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import DifferenceIcon from "@mui/icons-material/Difference";

// import KemperWholeLifeBranding from "./plans/kemper/wholeLife/branding/Branding";
// import KemperSTDBranding from "./plans/kemper/shortTermDisability/branding/Branding";
// import KemperCriticalIllnessBranding from "./plans/kemper/criticalIllness/branding/Branding";
// import KemperAccidentBranding from "./plans/kemper/accident/branding/Branding";
// import BeamVisionBranding from "./plans/beam/vision/branding/Branding";
// import { DocRxBranding, KemperHIBranding } from "..";
// import BeazleyGLIBranding from "./plans/beazley/indemnity/branding/Branding";
// import FiveStarBranding from "./plans/fiveStar/familyProtection/branding/Branding";
import { Member } from "../../../types/member.types";
import MacPlanForm from "./plans/macPlan/dental/form/macPlan";
import React from "react";
import { numberToDollarStr } from "../../../utils/commonFunctions/dollar";
import KemperAccidentBranding from "./plans/kemper/accident/branding/Branding";
import KemperAccidentForm from "./plans/kemper/accident/form/AccidentForm";
import KemperCriticalIllnessBranding from "./plans/kemper/criticalIllness/branding/Branding";
import KemperCriticalIllnessForm from "./plans/kemper/criticalIllness/form/CriticalIllness";
import KemperHospitalIndemnityBranding from "./plans/kemper/hospitalIndemnity/branding/Branding";
import KemperHospitalIndemnityForm from "./plans/kemper/hospitalIndemnity/form/HospitalIndemnityForm";
import KemperSTDBranding from "./plans/kemper/shortTermDisability/branding/Branding";
import KemperShortTermDisabilityForm from "./plans/kemper/shortTermDisability/form/ShortTermDisabilityForm";
import KemperWholeLifeBranding from "./plans/kemper/wholeLife/branding/Branding";
import KemperWholeLifeInsuaranceForm from "./plans/kemper/wholeLife/form/WholeLifeInsuranceForm";
import FiveStarBranding from "./plans/fiveStar/familyProtection/branding/Branding";
import FiveStarFamilyProtectionForm from "./plans/fiveStar/familyProtection/form/FamilyProtectionForm";
import DocRxBranding from "./plans/doc/docAndRx/branding/Branding";
import DoctorAndRxForm from "./plans/doc/docAndRx/form/DocAndRx";
import BeazleyGLIBranding from "./plans/beazley/indemnity/branding/Branding";
import BeazleyIndemnityForm from "./plans/beazley/indemnity/form/IndemnityForm";
import BeamVisionBranding from "./plans/beam/vision/branding/Branding";
import BeamVisionForm from "./plans/beam/vision/form/VisionForm";
import { VEBOpenEnrollment } from "../../../types/openEnrollment.types";
import { api } from "../../../utils/api";
import { EnrollmentSchema, Status, VEBEnrollmentSchema, VEBEnrollmentStatus } from "../../../types/enrollment.types";
import { VEBPlans } from "../../../types/components/enrollmentProps.types";
import VEBPlanAcknowledgement from "./plans/VEBPlanAknowledgement/VEBPlanAcknowledgement";
import EnrollmentTabLabel from "./enrollmentTabLabel/EnrollmentTabLabel";
import downloadFile from "../../../utils/commonFunctions/downloadFile";
import {
	Brochure,
	CancerBrochure,
	CriticalIllnessBrochure,
	HospitalndemnityBrochure,
	KemperAccidentBrochure,
	KemperShortTermBrochure,
	WholeLifeBrochure,
	GroupLifeIndemnity,
	Vision,
	DocRx,
	FamilyProtection,
	DentalPlan
} from "../../../assets";
import { trackPromise } from "react-promise-tracker";
import { dollarize } from "../../../utils/commonFunctions/dollarize";
import { EligiblityDialogProps } from "../../../types/components/eligiblityDialogProps.types";
import { VEBPlanName } from "../../../types/plan.types";
import EligiblityDialog from "./eligiblityDialogs/EligiblityDialog";
import DateTimePickerDialog from "../../shared/dialogs/dateTimePicker/DateTimePickerDialog";
import axios from "axios";
import { port, url } from "../../../config/config";

import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Chip } from "@material-ui/core";
import initCapitalize from "../../../utils/commonFunctions/initCapitalize";
import { VEBEnrollmentArray } from "../../../constants/VEBEnrollmentNext";
// import DateTimePickerDialog from "../../shared/dialogs/dateTimePicker/DateTimePickerDialog";
import EmailIcon from "@mui/icons-material/Email";
import CustomModal from "../../shared/customModal/CustomModal";
import KemperStackWholeLifeInsuaranceForm from "./plans/kemper/wholeLife/stackForm/KemperStackWholeLifeInsuaranceForm";
import StackForm from "./StackForm";
import { VEB_PLAN_NAME, VEB_PLAN_NAMES } from "../../../constants/plan";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.action.hover
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14
	}
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(even)": {
		backgroundColor: theme.palette.action.hover
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0
	}
}));

function a11yProps(index: number) {
	return {
		id: `vertical-tab-${index}`,
		"aria-controls": `vertical-tabpanel-${index}`
	};
}

const Enrollment = (): JSX.Element => {
	const [activeTab, setActiveTab] = useState<string>();
	const { currentEnrollment, setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);
	const [visitedPlans, setVisitedPlans] = useState<string[]>([]);
	const [value, setValue] = useState<string>();
	const [VEBEnrollmentStatus, setVEBEnrollmentStatus] = useState<VEBEnrollmentStatus | null>(null);
	const [VEBOpenEnrollment, setVEBOpenEnrollment] = useState<VEBOpenEnrollment[] | null>([]);
	const [VEBEnrollments, setVEBEnrollments] = useState<VEBEnrollmentSchema[]>([]);
	const [overallPremiums, setOverallPremiums] = useState<any[]>([]);
	const [dependents, setDependents] = useState<Member[]>([]);
	const [openEnrollments, setOpenEnrollments] = useState<any[]>([]);
	const [totalPremium, setTotalPremium] = useState<number>(0.0);
	const location = useLocation();
	const { theme } = useContext(ThemeContext);
	const { member } = useContext(AuthContext);
	const { eligiblity } = useContext(EligibleDependentContext);
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const height = screen.height;
	const [showOverallPremium, setShowOverallPremium] = useState(true);
	const [togglePlan, setTogglePlan] = useState(false);
	const [width, setWidth] = useState<number>(window.innerWidth);
	const history = useHistory();

	const [stackPlanName, setStackPlanName] = useState<string>("");

	const [VEBBenefits, setVEBBenefits] = useState<any>();

	const [openStackFormModal, setOpenStackFormModal] = useState<boolean>(false);

	// // console.log("VEBOpenEnrollment=========>", VEBOpenEnrollment);

	const overallPremiumChipColor = {
		ACTIVE: {
			background_color: "#d5e5d9",
			text_color: "#4cb464"
		},
		CURRENT: {
			background_color: "#f0ebc5",
			text_color: "#c9b30c"
		},
		WAIVED: {
			background_color: "#f7e9e9",
			text_color: "#eb2a2a"
		}
	};

	const speedDialActions = [
		// eslint-disable-next-line prettier/prettier
		{
			name: <div className="tooltip-speed-dial">Download&nbsp;Brochure</div>,
			icon: <DownloadIcon />,
			actionName: "download_brochure"
		},
		{
			name: <div className="tooltip-speed-dial">Email&nbsp;Brochure</div>,
			icon: <AttachEmailIcon />,
			actionName: "email_brochure"
		}
	];
	const [scheduleAppointmentDialogProps, setScheduleAppointmentDialogProps] = useState({
		openDialog: false,
		title: "Schedule an appointment with Enroller",
		actions: [
			{
				label: "Cancel",
				callback: () => {
					setScheduleAppointmentDialogProps(
						Object.assign({}, scheduleAppointmentDialogProps, { openDialog: false })
					);
				}
			},
			{
				label: "Confirm",
				callback: () => {
					setScheduleAppointmentDialogProps(
						Object.assign({}, scheduleAppointmentDialogProps, { openDialog: true })
					);
				}
			}
		]
	});
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>();
	const [scheduleAppointmentDateTime, setScheduleAppointmentDateTime] = useState(null);
	const [speedDialOpen, setSpeedDialOpen] = useState(true);

	const handleOpen = () => setSpeedDialOpen(true);

	const handleClose = () => setSpeedDialOpen(false);

	const handleToggle = () => {
		setTogglePlan(!togglePlan);
	};

	const handleEligibilityDialogOpen = useCallback(() => {
		// 	openDialog: boolean;
		// handleCloseEligiblityDialog: () => void;
		// eligibleDependents: Member[];
		// ineligibleRelationshipDependents: Member[];
		// ineligibleDependents: Member[];
		// VEBPlanName: VEBPlanName;
		if (!urlSearchParams.get("step")) {
			return;
		}
		setEligiblityDialogProps(
			Object.assign(
				{},
				{
					openDialog: true,
					handleCloseEligiblityDialog: () =>
						setEligiblityDialogProps(
							Object.assign({}, eligiblityDialogProps, {
								openDialog: false
							})
						),
					eligibleDependents: eligiblity.eligibleDependents,
					ineligibleRelationshipDependents: eligiblity.ineligibleRelationshipDependents,
					ineligibleDependents: eligiblity.ineligibleDependents,
					VEBPlanName: urlSearchParams.get("step") as VEBPlanName
				}
			)
		);
	}, [eligiblity, eligiblityDialogProps, urlSearchParams]);

	const handleChange = useCallback(
		(event: React.SyntheticEvent<Element, Event>, newValue: string) => {
			setActiveTab(newValue);
			setValue(newValue);
			deleteCurrentEnrollment();

			VEBEnrollmentArray.forEach((element, index) => {
				if (element === newValue) {
					const selectedRange = VEBEnrollmentArray.slice(0, index + 1);
					setVisitedPlans([...selectedRange]);
				}
			});
		},
		[deleteCurrentEnrollment]
	);

	// console.log("__visitePlans", visitedPlans);

	const initialVisitedPlans = useCallback(() => {
		setVisitedPlans(["Cancer"]);
	}, []);

	const getOpenEnrollments = useCallback(() => {
		const _openEnrollments = [
			{
				plan_name: "Cancer",
				status: "ENROLLED"
			},
			{
				plan_name: "Whole life",
				status: "ENROLLED"
			},
			{
				plan_name: "Short Term Disability",
				status: null
			},
			{
				plan_name: "Critical Illness",
				status: "WAIVED"
			},
			{
				plan_name: "Hospital Indemnity",
				status: "ENROLLED"
			},
			{
				plan_name: "Accident"
			},
			{
				plan_name: "Group Life Indemnity"
			},
			{
				plan_name: "Family Protection",
				status: "ENROLLED"
			},
			{
				plan_name: "Doc and Rx",
				status: "WAIVED"
			},
			{
				plan_name: "Vision",
				status: null
			},
			{
				plan_name: "Dental",
				status: "WAIVED"
			}
		];
		setOpenEnrollments(Object.assign([], _openEnrollments));
		//setActiveTab(_openEnrollments[0].plan_name);
	}, []);

	const handleOverallPremiumClick = () => {
		setShowOverallPremium((prevShowOverallPremium: boolean) => !prevShowOverallPremium);
	};

	const getOverallPremium = useCallback(() => {
		// console.log("VEBEnrollments", VEBEnrollments);
		const _overallPremiums: any[] = [];
		let activeVEBEnrollments: any[] = [];
		let waivedVEBEnrollments: any[] = [];
		const _overallPremiumsPayload: any[] = [];
		const _activeVEBEnrollmentsPlanName: any[] = [];
		activeVEBEnrollments = VEBEnrollments.filter((eachEnrollment: any) => {
			return eachEnrollment.enrollment_status === "ACTIVE";
		});

		// console.log("Active VEB Enrollments", activeVEBEnrollments);
		waivedVEBEnrollments = VEBEnrollments.filter((eachEnrollment: any) => {
			return eachEnrollment.enrollment_status === "WAIVED";
		});
		// console.log("Waived VEB Enrollments", waivedVEBEnrollments);
		// waivedVEBEnrollments.forEach((waivedEnrollment: any) => {
		// 	if (waivedVEBEnrollments.includes(waivedEnrollment.base_plan_name) === true) {
		// 		waivedVEBEnrollments.pop(wai)
		// 	}
		// })
		activeVEBEnrollments.forEach((activeVEBEnrollment: any) => {
			_activeVEBEnrollmentsPlanName.push(activeVEBEnrollment.base_plan_name);
			_overallPremiumsPayload.push(activeVEBEnrollment);
		});
		const pushedWaivedPlanNames: string[] = [];
		waivedVEBEnrollments.forEach((waivedVEBEnrollment: any) => {
			const { base_plan_name } = waivedVEBEnrollment;
			if (
				_activeVEBEnrollmentsPlanName.includes(base_plan_name) === false &&
				pushedWaivedPlanNames.includes(base_plan_name) === false
			) {
				_overallPremiumsPayload.push(waivedVEBEnrollment);
				pushedWaivedPlanNames.push(base_plan_name);
			}
		});
		// console.log("Plan Name", _activeVEBEnrollmentsPlanName);
		_overallPremiumsPayload.sort((prevEnroll, currentEnroll) => {
			return new Date(prevEnroll.createdAt).getTime() - new Date(currentEnroll.createdAt).getTime();
		});
		// console.log("Overall Payload", _overallPremiumsPayload);
		let _totalPremium = 0;
		_overallPremiumsPayload.map((VEBEnrollment: EnrollmentSchema) => {
			const { base_plan_name, premium_amount, enrollment_status, total_premium } = VEBEnrollment;
			if (base_plan_name !== currentEnrollment?.plan_name) {
				_overallPremiums.push({
					plan_name: base_plan_name,
					premium_amount: total_premium,
					status: enrollment_status
				});
				_totalPremium += total_premium;
			}
		});
		setTotalPremium(_totalPremium);
		setOverallPremiums(Object.assign([], _overallPremiums));
	}, [VEBEnrollments, currentEnrollment]);

	function handleWindowSizeChange() {
		setWidth(window.innerWidth);
	}

	const getVEBEnrollmentStatus = useCallback((planName: VEBPlans, VEBEnrollments: VEBEnrollmentSchema[]): Status => {
		let enrollment: Status = "CLOSED";
		// console.log("VEBp Enrollment", VEBEnrollments);
		for (let enrollmentIdx = 0; enrollmentIdx < VEBEnrollments.length; enrollmentIdx++) {
			if (VEBEnrollments[enrollmentIdx]?.base_plan_name === planName) {
				enrollment = VEBEnrollments[enrollmentIdx].enrollment_status;
				break;
			}
		}
		return enrollment;
	}, []);

	const getVEBEnrollmentInitData = useCallback(async () => {
		const { VEBOpenEnrollment, dependents, VEBEnrollments } = await trackPromise(
			api.pages.getVEBEnrollmentInitData()
		);
		if (VEBOpenEnrollment) {
			setVEBOpenEnrollment(Object.assign([], VEBOpenEnrollment));
		} else {
			setVEBOpenEnrollment(null);
		}
		setDependents(Object.assign([], dependents));
		// console.log("VEBEnrollments yy", VEBEnrollments);
		setVEBEnrollments(Object.assign([], VEBEnrollments));
		let _VEBEnrollmentStatus: VEBEnrollmentStatus = {
			Accident: {
				enrollment: "CLOSED"
			},
			Cancer: {
				enrollment: "CLOSED"
			},
			"Whole life": {
				enrollment: "CLOSED"
			},
			Dental: {
				enrollment: "CLOSED"
			},
			Vision: {
				enrollment: "CLOSED"
			},
			"Family Protection": {
				enrollment: "CLOSED"
			},
			"Critical Illness": {
				enrollment: "CLOSED"
			},
			"Hospital Indemnity": {
				enrollment: "CLOSED"
			},
			"Short Term Disability": {
				enrollment: "CLOSED"
			},
			"Doc and Rx": {
				enrollment: "CLOSED"
			},
			"Group Life Indemnity": {
				enrollment: "CLOSED"
			},
			"Group Limited Indemnity": {
				enrollment: "CLOSED"
			}
		};
		Object.entries(_VEBEnrollmentStatus).forEach(([planName], index) => {
			const status = getVEBEnrollmentStatus(planName as VEBPlans, VEBEnrollments);
			_VEBEnrollmentStatus = {
				..._VEBEnrollmentStatus,
				[planName]: {
					enrollment: status
				}
			};
		});
		setVEBEnrollmentStatus(Object.assign({}, _VEBEnrollmentStatus));
	}, [getVEBEnrollmentStatus]);

	console.log("VEBEnrollments================================================>", VEBEnrollments);
	const handleEmailBrochurePost = useCallback(async () => {
		const step = urlSearchParams.get("step");
		if (!step || !member) {
			return;
		}
		let _fileName;
		let _planName;
		switch (step) {
			case "Cancer":
				// _fileName = "Cancer_Kemper_Brochure_file.pdf";
				_planName = "Cancer";
				break;
			case "Whole life":
				// _fileName = "Whol_ Life_Kemper_Brochure_ Guide_file.pdf";
				_planName = "Whole life";
				break;
			case "Critical Illness":
				// _fileName = "Critica_ Illness_Kemper_Brochure_file.pdf";
				_planName = "Critical Illness";
				break;
			case "Short Term Disability":
				// _fileName = "Short_Term_Disability_Kemper_Brochure_file.pdf";
				_planName = "Short Term Disability";
				break;
			case "Accident":
				// _fileName = "Accident_Kemper_Brochure_file.pdf";
				_planName = "Accident";
				break;
			case "Hospital Indemnity":
				// _fileName = "HI_Plans1_2_3_4 with rates 092222 (2).pdf";
				_planName = "Hospital Indemnity";
				break;
			case "Group Life Indemnity":
				// _fileName = "Custom_EE_GLI-Brookshire_Bros_file.pdf";
				_planName = "Group Life Indemnity";
				break;
			case "Family Protection":
				// _fileName = "Term_Life_to_ Age_121_5Star_Brochure_Guide_file.pdf";
				_planName = "Family Protection";
				break;
			case "Doc and Rx":
				// _fileName = "Call_Up_A_Doc_file.pdf";
				_planName = "Doc and Rx";
				break;
			case "Vision":
				// _fileName = "Beam_file.pdf";
				_planName = "Vision";
				break;
			case "Dental":
				_planName = "Dental";
				break;
		}

		const { email, first_name, last_name } = member;
		const payload = {
			email: email,
			// filename: _fileName,
			plan_name: _planName,
			plan_code: _planName,
			subject: `Dear Employee: ${first_name} ${last_name} , Your plan brochure  `
		};
		const response = await trackPromise(api.email.emailBrochureVEBEnrollment(payload));
		if (response === 200) {
			alert("Email brochure has been successfully sent");
		}
		// if (response) {
		// 	alert("Email brochure has been successfully sent");
		// }
	}, [member, urlSearchParams]);

	const handleDownloadBrochureClick = useCallback(() => {
		const step = urlSearchParams.get("step");
		switch (step) {
			case "Cancer":
				downloadFile(CancerBrochure, "MedMutual_Cancer_Plan_Brochure");
				break;
			case "Whole life":
				downloadFile(WholeLifeBrochure, "MedMutual_Whole_Life_Plan_Brochure");
				break;
			case "Critical Illness":
				downloadFile(CriticalIllnessBrochure, "MedMutual_Critical_Illness_Plan_Brochure");
				break;
			case "Short Term Disability":
				downloadFile(KemperShortTermBrochure, "MedMutual_Short_Term_Brochure");
				break;
			case "Accident":
				downloadFile(KemperAccidentBrochure, "MedMutual_Accident_Plan_Brochure");
				break;
			case "Hospital Indemnity":
				downloadFile(HospitalndemnityBrochure, "MedMutual_Hospital_Indemnity_Plan_Brochure");
				break;
			case "Group Life Indemnity":
				downloadFile(GroupLifeIndemnity, "Group_Life_Indemnity_Plan_Brochure");
				break;
			case "Family Protection":
				downloadFile(FamilyProtection, "Family_Protection_Plan_Brochure");
				break;
			case "Doc and Rx":
				downloadFile(DocRx, "Doc_&_Rx_Plan_Brochure");
				break;
			case "Vision":
				downloadFile(Vision, "Vision_Plan_Brochure");
				break;
			case "Dental":
				// downloadFile(DentalPlan1, "Dental_Plan_Brochure");
				// downloadFile(DentalPlan2, "Dental_Plan_Brochure");
				// downloadFile(DentalPlan3, "Dental_Plan_Brochure");
				downloadFile(DentalPlan, "Dental_Plan_Brochure_All");
				break;
		}
	}, [urlSearchParams]);

	const handleScheduleAppointmentDialogClose = useCallback(() => {
		setScheduleAppointmentDialogProps(Object.assign({}, scheduleAppointmentDialogProps, { openDialog: false }));
	}, [scheduleAppointmentDialogProps]);

	const handleScheduleAppointmentDialogOpenClick = useCallback(() => {
		setScheduleAppointmentDialogProps((prevScheduleAppointmentDialogProps: any) =>
			Object.assign({}, prevScheduleAppointmentDialogProps, { openDialog: true })
		);
	}, []);

	const handleGetCurrentEnrollmentBenefitDetailsMail = useCallback(async () => {
		const { group_number, SSN } = member;

		const currentEnrollmentQuery = {
			group_number,
			SSN
		};

		try {
			const response = await api.enrollment.getEnrollmentCurrentBenefitEmail(currentEnrollmentQuery);
			if (response) alert("Successfully the mail has been sent!");
		} catch (error) {
			alert("Eror:404Something went wrong!");
		}
	}, [member]);

	const renderPlan = useCallback(() => {
		if (VEBEnrollmentStatus === null) {
			return;
		}
		const step = urlSearchParams.get("step");
		const stage = urlSearchParams.get("stage");
		console.log("step-------------", step, stage);
		switch (step) {
			case "Cancer": {
				if (stage === "0") {
					if (
						VEBEnrollmentStatus &&
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							VEBEnrollmentStatus["Cancer"].enrollment
						) &&
						VEBEnrollments
					) {
						return (
							<VEBPlanAcknowledgement
								VEBOpenEnrollment={VEBOpenEnrollment}
								VEBEnrollments={VEBEnrollments}
								VEBPlanName={"Cancer"}
							/>
						);
					} else {
						return (
							<KemperCancerBranding
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
								dependents={dependents}
								status={VEBEnrollmentStatus["Cancer"]}
							/>
						);
					}
				} else if (stage === "1") {
					if (VEBOpenEnrollment) {
						return (
							<KemperCancerForm
								dependents={dependents}
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<VEBPlanAcknowledgement
							VEBOpenEnrollment={VEBOpenEnrollment}
							VEBEnrollments={VEBEnrollments}
							VEBPlanName={"Cancer"}
						/>
					);
				}
				break;
			}
			case "Whole life": {
				if (stage === "0") {
					if (
						VEBEnrollmentStatus &&
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							VEBEnrollmentStatus["Whole life"].enrollment
						) &&
						VEBEnrollments
					) {
						return (
							<VEBPlanAcknowledgement
								handleStackEnrollmentClick={handleStackEnrollmentClick}
								VEBOpenEnrollment={VEBOpenEnrollment}
								VEBEnrollments={VEBEnrollments}
								VEBPlanName={"Whole life"}
							/>
						);
					} else {
						return (
							<KemperWholeLifeBranding
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
								dependents={dependents}
								status={VEBEnrollmentStatus["Whole life"]}
							/>
						);
					}
				} else if (stage === "1") {
					if (VEBOpenEnrollment) {
						return (
							<KemperWholeLifeInsuaranceForm
								dependents={dependents}
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<VEBPlanAcknowledgement
							handleStackEnrollmentClick={handleStackEnrollmentClick}
							VEBOpenEnrollment={VEBOpenEnrollment}
							VEBEnrollments={VEBEnrollments}
							VEBPlanName={"Whole life"}
						/>
					);
				}
				break;
			}
			case "Short Term Disability": {
				if (stage === "0") {
					if (
						VEBEnrollmentStatus &&
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							VEBEnrollmentStatus["Short Term Disability"].enrollment
						) &&
						VEBEnrollments
					) {
						return (
							<VEBPlanAcknowledgement
								VEBOpenEnrollment={VEBOpenEnrollment}
								VEBEnrollments={VEBEnrollments}
								VEBPlanName={"Short Term Disability"}
							/>
						);
					} else {
						return (
							<KemperSTDBranding
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
								dependents={dependents}
								status={VEBEnrollmentStatus["Short Term Disability"]}
							/>
						);
					}
				} else if (stage === "1") {
					if (VEBOpenEnrollment) {
						return (
							<KemperShortTermDisabilityForm
								dependents={dependents}
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<VEBPlanAcknowledgement
							VEBOpenEnrollment={VEBOpenEnrollment}
							VEBEnrollments={VEBEnrollments}
							VEBPlanName={"Short Term Disability"}
						/>
					);
				}
				// return stage === "0" ? <KemperSTDBranding /> : <KemperShortTermDisabilityForm />;
				break;
			}
			case "Critical Illness": {
				if (stage === "0") {
					if (
						VEBEnrollmentStatus &&
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							VEBEnrollmentStatus["Critical Illness"].enrollment
						) &&
						VEBEnrollments
					) {
						return (
							<VEBPlanAcknowledgement
								handleStackEnrollmentClick={handleStackEnrollmentClick}
								VEBOpenEnrollment={VEBOpenEnrollment}
								VEBEnrollments={VEBEnrollments}
								VEBPlanName={"Critical Illness"}
							/>
						);
					} else {
						return (
							<KemperCriticalIllnessBranding
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
								dependents={dependents}
								status={VEBEnrollmentStatus["Critical Illness"]}
							/>
						);
					}
				} else if (stage === "1") {
					if (VEBOpenEnrollment) {
						return (
							<KemperCriticalIllnessForm
								dependents={dependents}
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<VEBPlanAcknowledgement
							handleStackEnrollmentClick={handleStackEnrollmentClick}
							VEBOpenEnrollment={VEBOpenEnrollment}
							VEBEnrollments={VEBEnrollments}
							VEBPlanName={"Critical Illness"}
						/>
					);
				}
				break;
			}
			case "Accident": {
				if (stage === "0") {
					if (
						VEBEnrollmentStatus &&
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							VEBEnrollmentStatus["Accident"].enrollment
						) &&
						VEBEnrollments
					) {
						return (
							<VEBPlanAcknowledgement
								VEBOpenEnrollment={VEBOpenEnrollment}
								VEBEnrollments={VEBEnrollments}
								VEBPlanName={"Accident"}
							/>
						);
					} else {
						return (
							<KemperAccidentBranding
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
								dependents={dependents}
								status={VEBEnrollmentStatus["Accident"]}
							/>
						);
					}
				} else if (stage === "1") {
					if (VEBOpenEnrollment) {
						return (
							<KemperAccidentForm
								dependents={dependents}
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<VEBPlanAcknowledgement
							VEBOpenEnrollment={VEBOpenEnrollment}
							VEBEnrollments={VEBEnrollments}
							VEBPlanName={"Accident"}
						/>
					);
				}
				break;
			}
			case "Hospital Indemnity": {
				if (stage === "0") {
					if (
						VEBEnrollmentStatus &&
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							VEBEnrollmentStatus["Hospital Indemnity"].enrollment
						) &&
						VEBEnrollments
					) {
						return (
							<VEBPlanAcknowledgement
								VEBOpenEnrollment={VEBOpenEnrollment}
								VEBEnrollments={VEBEnrollments}
								VEBPlanName={"Hospital Indemnity"}
							/>
						);
					} else {
						return (
							<KemperHospitalIndemnityBranding
								VEBOpenEnrollment={VEBOpenEnrollment}
								dependents={dependents}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
								status={VEBEnrollmentStatus["Hospital Indemnity"]}
							/>
						);
					}
				} else if (stage === "1") {
					if (VEBOpenEnrollment) {
						return (
							<KemperHospitalIndemnityForm
								dependents={dependents}
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<VEBPlanAcknowledgement
							VEBOpenEnrollment={VEBOpenEnrollment}
							VEBEnrollments={VEBEnrollments}
							VEBPlanName={"Hospital Indemnity"}
						/>
					);
				}
				break;
			}
			case "Group Life Indemnity": {
				if (stage === "0") {
					if (
						VEBEnrollmentStatus &&
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							VEBEnrollmentStatus["Group Limited Indemnity"].enrollment
						) &&
						VEBEnrollments
					) {
						return (
							<VEBPlanAcknowledgement
								VEBOpenEnrollment={VEBOpenEnrollment}
								VEBEnrollments={VEBEnrollments}
								VEBPlanName={"Group Limited Indemnity"}
							/>
						);
					} else {
						return (
							<BeazleyGLIBranding
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
								dependents={dependents}
								status={VEBEnrollmentStatus["Group Limited Indemnity"]}
							/>
						);
					}
				} else if (stage === "1") {
					if (VEBOpenEnrollment) {
						return (
							<BeazleyIndemnityForm
								dependents={dependents}
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<VEBPlanAcknowledgement
							VEBOpenEnrollment={VEBOpenEnrollment}
							VEBEnrollments={VEBEnrollments}
							VEBPlanName={"Group Limited Indemnity"}
						/>
					);
				}
				break;
			}

			case "Family Protection": {
				if (stage === "0") {
					if (
						VEBEnrollmentStatus &&
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							VEBEnrollmentStatus["Family Protection"].enrollment
						) &&
						VEBEnrollments
					) {
						return (
							<VEBPlanAcknowledgement
								VEBOpenEnrollment={VEBOpenEnrollment}
								VEBEnrollments={VEBEnrollments}
								VEBPlanName={"Family Protection"}
							/>
						);
					} else {
						return (
							<FiveStarBranding
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
								dependents={dependents}
								status={VEBEnrollmentStatus["Family Protection"]}
							/>
						);
					}
				} else if (stage === "1") {
					if (VEBOpenEnrollment) {
						return (
							<FiveStarFamilyProtectionForm
								dependents={dependents}
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<VEBPlanAcknowledgement
							VEBOpenEnrollment={VEBOpenEnrollment}
							VEBEnrollments={VEBEnrollments}
							VEBPlanName={"Family Protection"}
						/>
					);
				}
				break;
			}
			case "Doc and Rx": {
				if (stage === "0") {
					if (
						VEBEnrollmentStatus &&
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							VEBEnrollmentStatus["Doc and Rx"].enrollment
						) &&
						VEBEnrollments
					) {
						return (
							<VEBPlanAcknowledgement
								VEBOpenEnrollment={VEBOpenEnrollment}
								VEBEnrollments={VEBEnrollments}
								VEBPlanName={"Doc and Rx"}
							/>
						);
					} else {
						return (
							<DocRxBranding
								VEBOpenEnrollment={VEBOpenEnrollment}
								dependents={dependents}
								status={VEBEnrollmentStatus["Doc and Rx"]}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "1") {
					if (VEBOpenEnrollment) {
						return (
							<DoctorAndRxForm
								dependents={dependents}
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<VEBPlanAcknowledgement
							VEBOpenEnrollment={VEBOpenEnrollment}
							VEBEnrollments={VEBEnrollments}
							VEBPlanName={"Doc and Rx"}
						/>
					);
				}
				break;
			}
			case "Dental": {
				if (stage === "0") {
					if (
						VEBEnrollmentStatus &&
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							VEBEnrollmentStatus["Dental"].enrollment
						) &&
						VEBEnrollments
					) {
						return (
							<VEBPlanAcknowledgement
								VEBOpenEnrollment={VEBOpenEnrollment}
								VEBEnrollments={VEBEnrollments}
								VEBPlanName={"Dental"}
							/>
						);
					} else {
						return (
							<MaxDentalBranding
								VEBOpenEnrollment={VEBOpenEnrollment}
								dependents={dependents}
								status={VEBEnrollmentStatus["Dental"]}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "1") {
					if (VEBOpenEnrollment) {
						return (
							<MacPlanForm
								dependents={dependents}
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<VEBPlanAcknowledgement
							VEBOpenEnrollment={VEBOpenEnrollment}
							VEBEnrollments={VEBEnrollments}
							VEBPlanName={"Dental"}
						/>
					);
				}
				break;
			}
			case "Vision": {
				if (stage === "0") {
					if (
						VEBEnrollmentStatus &&
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							VEBEnrollmentStatus["Vision"].enrollment
						) &&
						VEBEnrollments
					) {
						return (
							<VEBPlanAcknowledgement
								VEBOpenEnrollment={VEBOpenEnrollment}
								VEBEnrollments={VEBEnrollments}
								VEBPlanName={"Vision"}
							/>
						);
					} else {
						return (
							<BeamVisionBranding
								VEBOpenEnrollment={VEBOpenEnrollment}
								dependents={dependents}
								status={VEBEnrollmentStatus["Vision"]}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "1") {
					if (VEBOpenEnrollment) {
						return (
							<BeamVisionForm
								dependents={dependents}
								VEBOpenEnrollment={VEBOpenEnrollment}
								getVEBEnrollmentInitData={getVEBEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<VEBPlanAcknowledgement
							VEBOpenEnrollment={VEBOpenEnrollment}
							VEBEnrollments={VEBEnrollments}
							VEBPlanName={"Vision"}
						/>
					);
				}
				break;
			}
		}
	}, [VEBEnrollmentStatus, VEBEnrollments, VEBOpenEnrollment, dependents, getVEBEnrollmentInitData, urlSearchParams]);

	const handleOpenStackFormModalClick = () => {
		setOpenStackFormModal(true);
	};
	const handleCloseStackFormModalClick = () => {
		setOpenStackFormModal(false);
	};

	const handleStackEnrollmentClick = useCallback(async () => {
		const step = urlSearchParams.get("step");

		setStackPlanName(step ? step : "");

		const getBenefitsQuery: any = {
			base_plan_name: step,
			// group_number: member.group_number,
			insured_SSN: member.SSN
			// member_SSN: member.SSN
		};
		const benefitsResponse: any = (
			await trackPromise(api.enrollment.getActiveVEBEnrollmentWithRider(getBenefitsQuery))
		).vebEnrollmentsForStack;

		setVEBBenefits(benefitsResponse);

		handleOpenStackFormModalClick();
	}, [member, urlSearchParams]);

	useEffect(() => {
		getVEBEnrollmentInitData();
		initialVisitedPlans();
	}, [getVEBEnrollmentInitData, initialVisitedPlans]);

	useEffect(() => {
		getOpenEnrollments();
		getOverallPremium();
	}, [getOpenEnrollments, getOverallPremium, VEBEnrollments]);

	useEffect(() => {
		if (activeTab) {
			history.push("?step=" + activeTab + "&stage=0");
			// console.log("step", activeTab);
		}
	}, [activeTab, history]);

	useEffect(() => {
		// console.log("VEBEnrollmentss", VEBEnrollments);
		if (currentEnrollment) {
			const _overallPremiums: any[] = [];
			let _totalPremium = 0;
			VEBEnrollments.forEach((VEBEnrollment: EnrollmentSchema) => {
				const { base_plan_name, premium_amount, enrollment_status } = VEBEnrollment;
				if (base_plan_name !== currentEnrollment?.plan_name) {
					_overallPremiums.push({
						plan_name: base_plan_name,
						premium_amount: premium_amount,
						status: enrollment_status
					});
					_totalPremium += premium_amount;
				}
			});
			setTotalPremium(() => Number((_totalPremium + currentEnrollment.premium_amount).toFixed(2)));
		}
	}, [VEBEnrollments, currentEnrollment]);

	useEffect(() => {
		window.addEventListener("resize", handleWindowSizeChange);
		setActiveTab("Cancer");
		return () => {
			window.removeEventListener("resize", handleWindowSizeChange);
		};
	}, []);

	useEffect(() => {
		const timer = setTimeout(handleScheduleAppointmentDialogOpenClick, 1000);
		return () => clearTimeout(timer);
	}, [handleScheduleAppointmentDialogOpenClick]);

	// // console.log("VEBEnrollmentStatus", VEBEnrollmentStatus);

	useEffect(() => {
		// // console.log("i am running", urlSearchParams);
		if (
			!urlSearchParams ||
			urlSearchParams == undefined ||
			urlSearchParams.get("step") == undefined ||
			!urlSearchParams.get("step")
		) {
			if (activeTab) {
				history.push("?step=" + activeTab + "&stage=0");
			} else {
				initialVisitedPlans();
			}
		}
	}, [activeTab, history, initialVisitedPlans, urlSearchParams, visitedPlans]);

	return (
		<>
			<DateTimePickerDialog
				customDateTimePickerDialogProps={scheduleAppointmentDialogProps}
				handleClose={handleScheduleAppointmentDialogClose}
			/>
			{eligiblityDialogProps ? (
				<Suspense fallback={<div />}>
					<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
				</Suspense>
			) : null}

			<Suspense fallback={<div />}>
				<CustomModal open={openStackFormModal} onClose={handleCloseStackFormModalClick} title="">
					<StackForm
						onClose={handleCloseStackFormModalClick}
						VEBOpenEnrollment={VEBOpenEnrollment}
						getVEBEnrollmentInitData={getVEBEnrollmentInitData}
						planName={stackPlanName}
						vebBenefits={VEBBenefits}
					/>
				</CustomModal>
			</Suspense>
			<div className="veb-enrollment">
				<Box
					className="box-container"
					sx={{
						flexGrow: 1,
						//bgcolor: "background.paper",
						display: "block",
						marginLeft: "-2rem"
					}}
				>
					<div
						className={
							!togglePlan && width <= 820 ? "open-plan-list show-list" : "open-plan-list hide-list"
						}
						onClick={handleToggle}
					>
						<KeyboardArrowRightIcon className="arrow-icon" style={{ color: theme.button.color }} />
						Show Plans
					</div>
					{/* <Slide direction="right" in={togglePlan} mountOnEnter unmountOnExit>
						<div
							className={!togglePlan ? "close-plan-list hide-list" : "close-plan-list show-list"}
							onClick={handleToggle}
						>
							Hide Plans
						</div>
					</Slide> */}
					{width <= 820 ? (
						<Slide direction="right" in={togglePlan} mountOnEnter unmountOnExit>
							<div className="show-plan">
								<div className="close-plan-list show-list" onClick={handleToggle}>
									Hide Plans
								</div>
								<Tabs
									orientation="vertical"
									className="tabs-container"
									// variant="scrollable"
									//variant="fullWidth"
									style={{
										// boxShadow:
										//"rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset",
										boxShadow:
											"rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
										borderTopLeftRadius: 20,
										borderTopRightRadius: 20,
										borderBottomLeftRadius: 20,
										borderBottomRightRadius: 20,
										color: theme.primary_color
									}}
									TabIndicatorProps={{
										style: {
											color: theme.primary_color,
											backgroundColor: theme.primary_color
										}
									}}
									value={value}
									onChange={handleChange}
								>
									{VEBEnrollmentStatus &&
										openEnrollments.map((openEnrollment: any, index: number) => {
											const { plan_name, status } = openEnrollment;

											return (
												<Tab
													key={index}
													className={
														activeTab === plan_name
															? visitedPlans.includes(plan_name)
																? "VEB-active-tab VEB-TAB-tracker"
																: "VEB-active-tab"
															: visitedPlans.includes(plan_name)
															? "VEB-active-tab VEB-TAB-tracker"
															: "VEB-default-tab"
													}
													style={{
														height: (height - 500) / 6,
														color: activeTab == plan_name ? theme.primary_color : undefined
													}}
													value={plan_name}
													onClick={handleToggle}
													label={
														VEBEnrollmentStatus[plan_name as keyof VEBEnrollmentStatus]
															?.enrollment ? (
															<EnrollmentTabLabel
																planName={plan_name}
																status={
																	VEBEnrollmentStatus[
																		plan_name as keyof VEBEnrollmentStatus
																	].enrollment
																}
																isOpenEnrollment={
																	VEBOpenEnrollment && VEBOpenEnrollment.length > 0
																		? true
																		: false
																}
																carrier="Kemper"
															/>
														) : null
													}
													{...a11yProps(0)}
												/>
											);
										})}
								</Tabs>
							</div>
						</Slide>
					) : (
						<Tabs
							orientation="vertical"
							className={!togglePlan ? "tabs-cotainer" : "tabs-cotainer show-plan"}
							// variant="scrollable"
							//variant="fullWidth"
							style={{
								// boxShadow:
								//"rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset",
								boxShadow: "rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
								borderTopLeftRadius: 20,
								borderTopRightRadius: 20,
								borderBottomLeftRadius: 20,
								borderBottomRightRadius: 20,
								color: theme.primary_color
							}}
							TabIndicatorProps={{
								style: {
									color: theme.primary_color,
									backgroundColor: theme.primary_color
								}
							}}
							value={value}
							onChange={handleChange}
						>
							{VEBEnrollmentStatus &&
								openEnrollments.map((openEnrollment: any, index: number) => {
									const { plan_name, status } = openEnrollment;
									return (
										<Tab
											key={index}
											className={activeTab == plan_name ? "VEB-active-tab" : "VEB-default-tab"}
											style={{
												height: (height - 500) / 6,
												color: activeTab == plan_name ? theme.primary_color : undefined
											}}
											value={plan_name}
											onClick={handleToggle}
											label={
												VEBEnrollmentStatus[plan_name as keyof VEBEnrollmentStatus]
													?.enrollment ? (
													<EnrollmentTabLabel
														planName={plan_name}
														status={
															VEBEnrollmentStatus[plan_name as keyof VEBEnrollmentStatus]
																.enrollment
														}
														isOpenEnrollment={
															VEBOpenEnrollment && VEBOpenEnrollment.length > 0
																? true
																: false
														}
														carrier="Kemper"
													/>
												) : null
											}
											{...a11yProps(0)}
										/>
									);
								})}
						</Tabs>
					)}

					<div className="form-container">{renderPlan()}</div>
				</Box>
				{showOverallPremium ? (
					<Draggable>
						<div className="draggable-premium-box">
							<div>
								<div
									className={"top-bar-expand"}
									style={{ backgroundColor: theme.button.background_color }}
								>
									<div className="header" style={{ color: theme.button.color }}>
										Overall Premium (Current OE)
									</div>
									<div className={"icon-expand"}>
										<IconButton onClick={handleOverallPremiumClick}>
											<KeyboardArrowRightIcon style={{ color: theme.button.color }} />
										</IconButton>
									</div>
								</div>
							</div>
							<div>
								<div
									style={{
										backgroundColor: "#e3e1e1",
										padding: "1rem",
										display: "flex",
										fontWeight: "bold",
										alignItems: "center",
										gap: "20%"
									}}
								>
									<div className="header" style={{ color: "#242424", flex: "1" }}>
										{/* <span>VEB</span> */}
										<span>VEB&nbsp;Plan(s)</span>
									</div>

									<div className="header" style={{ fontSize: "1rem", marginLeft: "2rem", flex: "3" }}>
										Premium&nbsp;($)
									</div>
									<div
										className="header"
										style={{ color: "#242424", marginRight: "12rem", flex: "1" }}
									>
										Status
									</div>
								</div>
							</div>
							<TableContainer
								component={Paper}
								style={{ zIndex: 99999, maxHeight: "300px", overflowY: "auto" }}
							>
								<Table sx={{ minWidth: 300 }} aria-label="customized table">
									{/* <TableHead>
										<TableRow>
											<StyledTableCell>
												<span className="premium-table-header">Plan</span>
											</StyledTableCell>
											<StyledTableCell align="right">
												<span className="premium-table-header">Premium&nbsp;($)</span>
											</StyledTableCell>
											<StyledTableCell align="right">
												<span className="premium-table-header">Status</span>
											</StyledTableCell>
										</TableRow>
									</TableHead> */}
									<TableBody>
										{overallPremiums.map((overallPremium: any, index: number) => (
											<StyledTableRow key={index}>
												<StyledTableCell component="th" scope="row">
													{overallPremium.plan_name}
												</StyledTableCell>
												<StyledTableCell align="right">
													{overallPremium.premium_amount.toFixed(2)}
												</StyledTableCell>
												{overallPremium.status ? (
													<StyledTableCell align="right">
														<Chip
															label={initCapitalize(overallPremium.status)}
															style={{
																backgroundColor: `${
																	overallPremium.status === "ACTIVE"
																		? overallPremiumChipColor.ACTIVE
																				.background_color
																		: overallPremium.status === "WAIVED"
																		? overallPremiumChipColor.WAIVED
																				.background_color
																		: null
																}`,
																color: `${
																	overallPremium.status === "ACTIVE"
																		? overallPremiumChipColor.ACTIVE.text_color
																		: overallPremium.status === "WAIVED"
																		? overallPremiumChipColor.WAIVED.text_color
																		: null
																}`,
																fontWeight: "700"
															}}
														/>
													</StyledTableCell>
												) : null}
											</StyledTableRow>
										))}
										{currentEnrollment ? (
											<StyledTableRow>
												<StyledTableCell component="th" scope="row">
													{currentEnrollment.plan_name}
												</StyledTableCell>
												<StyledTableCell align="right">
													{currentEnrollment.premium_amount}
												</StyledTableCell>
												<StyledTableCell align="right">
													<Chip
														label={initCapitalize(currentEnrollment.status)}
														style={{
															backgroundColor:
																overallPremiumChipColor.CURRENT.background_color,
															color: overallPremiumChipColor.CURRENT.text_color,
															fontWeight: "700"
														}}
													/>
												</StyledTableCell>
											</StyledTableRow>
										) : null}
									</TableBody>
								</Table>
							</TableContainer>
							<div>
								<div
									style={{
										backgroundColor: "#e3e1e1",
										padding: "0.3rem",
										display: "flex",
										fontWeight: "bold",
										alignItems: "center",
										gap: "20%"
									}}
								>
									<div className="header" style={{ color: "#242424", marginLeft: "1rem" }}>
										TOTAL AMOUNT
									</div>

									<div className="show-premium" style={{ fontSize: "1.3rem" }}>
										{dollarize(Number(totalPremium.toFixed(2))) + (currentEnrollment ? "*" : "")}
									</div>
								</div>
							</div>
						</div>
					</Draggable>
				) : (
					<Draggable axis="y">
						<div className="draggable-premium-box">
							<div>
								<div className={"top-bar"} style={{ backgroundColor: theme.button.background_color }}>
									<div className="header" style={{ color: theme.button.color }}>
										Overall Amount
									</div>
									<div className={"icon"}>
										<IconButton onClick={handleOverallPremiumClick}>
											<KeyboardArrowRightIcon style={{ color: theme.button.color }} />
										</IconButton>
									</div>
								</div>
							</div>
						</div>
					</Draggable>
				)}
			</div>

			<Tooltip title="Get Current Benefit Details">
				<Fab
					sx={{
						position: "fixed",
						bottom: 18,
						right: 156,
						bgcolor: theme.primary_color,
						"&:hover": {
							bgcolor: theme.primary_color
						}
					}}
					onClick={handleGetCurrentEnrollmentBenefitDetailsMail}
				>
					<EmailIcon style={{ color: "white" }} />
				</Fab>
			</Tooltip>

			<Fab onClick={handleScheduleAppointmentDialogOpenClick} sx={{ position: "fixed", bottom: 18, right: 86 }}>
				<DateRangeIcon />
			</Fab>

			<SpeedDial
				ariaLabel="SpeedDial tooltip example"
				sx={{ position: "fixed", bottom: 16, right: 16 }}
				icon={<SpeedDialIcon />}
				onOpen={handleOpen}
				onClose={handleClose}
				open={speedDialOpen}
				style={{ fontSize: "10px" }}
				FabProps={{
					sx: {
						bgcolor: theme.primary_color,
						"&:hover": {
							bgcolor: theme.primary_color
						}
					}
				}}
			>
				{speedDialActions.map((speedDialAction: any) => (
					<SpeedDialAction
						key={speedDialAction.name}
						icon={speedDialAction.icon}
						tooltipTitle={<div className="tooltip-speed-dial">{speedDialAction.name}</div>}
						tooltipOpen
						onClick={
							speedDialAction.actionName === "email_brochure"
								? handleEmailBrochurePost
								: handleDownloadBrochureClick
						}
						style={{ fontSize: "10px" }}
					/>
				))}
				{urlSearchParams.get("stage") === "1" && urlSearchParams.get("step") !== "Short Term Disability" ? (
					<SpeedDialAction
						icon={<DifferenceIcon />}
						tooltipTitle={<div className="tooltip-speed-dial">Check&nbsp;Eligibility</div>}
						tooltipOpen
						onClick={handleEligibilityDialogOpen}
						// speedDialAction.actionName === "email_brochure"
						// 	? handleEmailBrochurePost
						// 	: handleDownloadBrochureClick

						style={{ fontSize: "10px" }}
					/>
				) : null}
				<SpeedDialAction
					icon={<AttachFileIcon />}
					tooltipTitle={<div className="tooltip-speed-dial">Generate&nbsp;Eligibility</div>}
					tooltipOpen
					onClick={async () => {
						try {
							const res = await trackPromise(
								axios.get(`${url}:${port}/api/v1/carrier-transmission/kemper`)
							);
							if (res) alert("Succesfully generated! Check your email");
						} catch (err) {
							alert(err);
						}
					}}
					// speedDialAction.actionName === "email_brochure"
					// 	? handleEmailBrochurePost
					// 	: handleDownloadBrochureClick

					style={{ fontSize: "10px" }}
				/>
			</SpeedDial>
		</>
	);
};

export default Enrollment;
